import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import Publish from "./views/Publish.vue";
import Search from "./views/Search.vue";
import MapSearch from "./views/MapSearch.vue";
import AboutUs from "./views/AboutUs.vue";
import ThankYou from "./views/ThankYou.vue";
import AppFooter from "./layout/AppFooter.vue";
import Form from "./views/Form.vue";
import AppHeaderButtonless from "./layout/AppHeaderButtonless.vue";
import Chat from "./views/Chat.vue"
import { splitClient, ensureSplitClientReady } from './plugins/split';

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "*",
      redirect: "/search"
    },
    {
      path: "/",
      async beforeEnter(to, from, next) {
        await ensureSplitClientReady();
        const treatment = splitClient.getTreatment('ab_testing_map_search_loteperfecto');
        if (treatment === 'on') {
          next('/map-search');
        } else {
          next('/search');
        }
      },
      meta: {
        canonicalUrl: 'https://www.loteperfecto.com/search'
      }
    },
    {
      path: "/search",
      name: "search",
      components: {
        header: AppHeader,
        default: Search,
        footer: AppFooter
      },
      meta: {
        title: "Encuentra el Lote Agro ideal | LotePerfecto",
        description: "Explora una selección de campos en alquiler en Argentina. Con nuestra herramienta inteligente, encontrar el terreno ideal nunca fue tan fácil.",
        canonicalUrl: 'https://www.loteperfecto.com/search'
      }
    },
    {
      path: "/map-search",
      name: "map-search",
      components: {
        header: AppHeader,
        default: MapSearch,
        footer: AppFooter
      },
      meta: {
        title: "Descubre el Lote Agro Perfecto en el Mapa | LotePerfecto",
        description: "Explora una selección de campos en alquiler en Argentina. Con nuestra herramienta inteligente, encontrar el terreno ideal nunca fue tan fácil.",
        canonicalUrl: 'https://www.loteperfecto.com/search'
      }
    },
    {
      path: "/#/publish",
      name: "publish-offer",
      components: {
        header: AppHeader,
        default: Publish,
        footer: AppFooter
      },
      meta: {
        title: "Publica y Alquila tu Lote en LotePerfecto"
      }
    },
    {
      path: "/typ",
      name: "thankyou",
      components: {
        header: AppHeader,
        default: ThankYou,
        footer: AppFooter
      },
      meta: {
        title: "Solicitud Recibida | LotePerfecto"
      }
    },
    {
      path: "/typ-offer",
      name: "thanks-offer",
      components: {
        header: AppHeader,
        default: ThankYou,
        footer: AppFooter
      },
      meta: {
        title: "¡Gracias por Publicar tu Lote! | LotePerfecto"
      }
    },
    {
      path: "/publish",
      redirect: "/offer"
    },
    {
      path: "/offer",
      name: "publish",
      components: {
        header: AppHeader,
        default: Publish,
        footer: AppFooter
      },
      meta: {
        title: "Publica y Alquila tu Lote en LotePerfecto",
        description: "Ofrece tu lote agrícola en Argentina con nuestra plataforma avanzada. Conecta con productores y maximiza el valor de tu campo fácilmente."
      }
    },
    {
      path: "/about-us",
      name: "aboutUs",
      components: {
        header: AppHeader,
        default: AboutUs,
        footer: AppFooter
      },
      meta: {
        title: "LotePerfecto | Sobre Nosotros",
        description: "LotePerfecto es la solución para propietarios y productores en Argentina que buscan maximizar el potencial de sus campos a través del alquiler eficiente."
      }
    },
    {
      path: "/search-registration",
      name: "search-registration",
      components: {
        header: AppHeader,
        default: Form,
        footer: AppFooter
      },
      meta: {
        formId: '240423532685051',
        title: "Registra tu Búsqueda de Lotes | LotePerfecto"
      }
    },
    {
      path: "/offer-registration",
      name: "offer-registration",
      components: {
        header: AppHeader,
        default: Form,
        footer: AppFooter
      },
      meta: {
        formId: '232683565816062',
        title: "Describe tu Lote en Alquiler para Publicarlo | LotePerfecto"
      }
    },
    {
      path: "/chat",
      name: "chat",
      components: {
        header: AppHeaderButtonless,
        default: Chat,
        footer: AppFooter
      },
      meta: {
        title: "Chat | LotePerfecto"
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "LotePerfecto | Alquiler de Lotes Agro";

  const defaultDescription = 'La primera plataforma inteligente que conecta propietarios con productores, maximizando el potencial de tu campo.'
  const descriptionElement = document.querySelector('head meta[name="description"]')
  const descriptionElementOG = document.querySelector('head meta[property="og:description"]')
  descriptionElement.setAttribute('content', to.meta.description || defaultDescription)
  descriptionElementOG.setAttribute('content', to.meta.description || defaultDescription)

  if (to.meta.canonicalUrl) {
    let link = document.querySelector('head link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', to.meta.canonicalUrl);
  }

  next();
})

export default router;
